















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import UserRoleMixin from '@/mixins/UserRoleMixin.vue';
import {Mixins} from 'vue-property-decorator';
import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';
import {isEmail, isPhone, nil} from '@/common';
import RegisterDialog from '@/components/Views/Customer/RegisterDialog.vue';
import {FeathersVuexFindOne} from '@/utils';
import GenericDialog from '@/components/Views/UI/GenericDialog.vue';

@Component({
    components: {GenericDialog, RegisterDialog},
})
export default class CompletePurchaseDialog extends Mixins(UserRoleMixin, GlobalAlertMixin) {

    public get loginButtonText() {
        return this.loginMode ? 'I\'m a new customer' : 'I have an account';
    }
    @Prop({default: false})
    public manualApproval!: boolean;
    public open = false;
    public valid = false;
    public loginMode = false;
    public email = '';
    public phone = '';
    public password = '';

    public emailRules = [
        (v) => !!v || 'Email is required!',
        (v) => isEmail(v) || 'Invalid Email',
    ];
    public phoneRules = [
        (v) => !!v || 'A Phone number is required!',
        (v) => isPhone(v) || 'Invalid Phone',
    ];
    public passwordRules = [
        (v) => !!v || 'Password is required',
    ];
    @Watch('open')
    public onOpenChanged(value: boolean, oldValue: boolean) {
        if (!value) {
            this.$emit('onClosed');
        }
    }

    public async completePurchase() {
        const {Purchaser} = this.$FeathersVuex;
        if (this.loginMode) {
            try {
                try {
                    const l = await this.$store.dispatch('auth/authenticate', {
                        email: this.email,
                        password: this.password,
                        strategy: 'local',
                    });
                    const p = await Purchaser.find({
                        query: {
                            user: this.user._id,
                        },
                    });
                    if (p.total === 1) {
                        this.$emit('input', p.data[0]);
                    } else {
                        this.createNewPurchaser();
                    }
                } catch (e) {
                    this.showAlert(e);
                }
            } catch (e) {
                this.showAlert(e);
            }
        } else {
            const p = await FeathersVuexFindOne(Purchaser, {query: {email: this.email}});
            if (nil(p) || nil(p.user)) {
                this.createNewPurchaser();
            } else {
                this.switchToLoginMode();
            }
        }
    }


    private async createNewPurchaser() {
        const {Purchaser} = this.$FeathersVuex;
        const p = new Purchaser({
            phone: this.phone,
            email: this.email,
        });
        try {
            const purchaser = await p.create();
            this.$emit('input', purchaser);
        } catch (e) {
            if (e.code === 409 && e.message.indexOf('vendors') > -1) {
                this.showAlert('This email already belongs to a pro, please use a different email for purchases!');
            } else if (e.code === 409) {
                const search = await Purchaser.find({query: {email: this.email}});
                const [existing] = search.data;
                if (nil(existing.user)) {
                    (this.$refs.registerDialog as any).openWith(existing);
                } else {
                    this.switchToLoginMode();
                }
            } else {
                this.showAlert('We\'re sorry! There was a problem creating your account! Please contact support@soplushbeauty.com');
            }
        }
    }
    private switchToLoginMode() {
        this.loginMode = true;
        setTimeout(() => {
            (this.$refs.passwordField as any).focus();
        }, 250);
        this.showAlert('There\'s already a user registered with this email, please login!', 'warning');
    }
    private onRegister(purchaser) {
        this.$emit('input', purchaser);
    }
}
